import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../../../api/client";

// GET /api/v1/teacher-payouts/preview/?teacher={id}&from=YYYY-MM-DD&to=YYYY-MM-DD
// → { hours_pending, amount_pending, breakdown[], rate_source }
// Contract: TASK-15 §8
function usePayoutPreview({ teacher, from, to } = {}) {
  return useQuery({
    queryKey: ["teacher-payouts", "preview", { teacher, from, to }],
    queryFn: () => {
      const params = { teacher };
      if (from) params.from = from;
      if (to) params.to = to;
      return apiClient
        .get("/api/v1/teacher-payouts/preview/", { params })
        .then((r) => r.data);
    },
    // Runs with just a teacher (from defaults to the oldest pending class).
    enabled: !!teacher && !!to,
  });
}

export { usePayoutPreview };
